import React from 'react';
import { Document } from '@react-pdf/renderer';
import type { AdmissionEnquiry } from '../../../types/admissions';
import {
  Page, DataTable, SummaryLine, tally,
  type SchoolBranding, type DocumentMeta,
} from '../../../utils/pdf';
import { statusLabel } from '../../common/StatusChip';
import { ENQUIRY_EXPORT_COLUMNS, ENQUIRY_PDF_TONE } from '../enquiries/enquiryExport';
import { exportPdfColumns } from './exportColumns';

interface Props {
  enquiries: AdmissionEnquiry[];
  branding: SchoolBranding;
  meta: DocumentMeta;
}

const columns = exportPdfColumns(ENQUIRY_EXPORT_COLUMNS, e => ENQUIRY_PDF_TONE[e.status]);

/** EnquiriesListDocument — the call list: every enquiry the filters match, landscape, with how many are at each status. */
const EnquiriesListDocument: React.FC<Props> = ({ enquiries, branding, meta }) => {
  const byStatus = tally(enquiries, e => statusLabel({ kind: 'enquiry', value: e.status }), e => ENQUIRY_PDF_TONE[e.status]);

  return (
    <Document title={meta.title} author={branding.name}>
      <Page
        branding={branding}
        meta={meta}
        orientation="landscape"
        official={{ details: [
          ...(meta.subtitle ? [{ value: meta.subtitle }] : []),
          { value: `${enquiries.length} enquir${enquiries.length === 1 ? 'y' : 'ies'}` },
        ] }}
      >
        <SummaryLine groups={[{ label: 'By status', items: byStatus }]} />
        <DataTable columns={columns} rows={enquiries} zebra compact />
      </Page>
    </Document>
  );
};

export default EnquiriesListDocument;
